import cService from '@API/Request/cService'
import axios from '@axios'

const { ddService } = cService(axios, {})
export default ddService
